import React, { PureComponent } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { connect } from 'react-redux';

// ducks
import { paginateThis } from '../../ducks/DesignationSearch';

// modules
import styles from '../Containers.module.scss';

// components
import DesignationSearchResults from './DesignationSearchResults';

class DesignationSearch extends PureComponent {
  render() {
    return (
      <Container fluid className={styles.DesignationSearch}>
        <Container>
          <Row>
            <Breadcrumb>
              <LinkContainer exact to="/">
                <BreadcrumbItem>
                  <Link to="/">Home</Link>
                </BreadcrumbItem>
              </LinkContainer>
              <LinkContainer exact to="/designations">
                <BreadcrumbItem active>
                  REALTOR<sup>®</sup> Designations
                </BreadcrumbItem>
              </LinkContainer>
            </Breadcrumb>
          </Row>
        </Container>
        <Container>
          <p>
            The NATIONAL ASSOCIATION OF REALTORS<sup>®</sup> and its affiliated
            Institutes, Societies, and Councils provide a wide-ranging menu of programs
            and services that assist members in increasing skills, productivity and
            knowledge. Designations and certifications acknowledging experience and
            expertise in various real estate sectors are awarded by each Affiliated group
            upon completion of required courses. In addition, NAR offers several
            certification programs to its members.
          </p>
          <DesignationSearchResults listId="designations" className={styles.results} />
        </Container>
      </Container>
    );
  }
}

export default connect(() => ({ autoload: true }))(
  paginateThis.decorate(DesignationSearch, {})
);



// WEBPACK FOOTER //
// ./src/containers/DesignationSearch/DesignationSearch.js